<template>
  <div :class="[`premium-1`, className || ``]">
    <div class="overlap-group1-6">
      <div class="flex-row-2">
        <img
          class="business-pro"
          src="/otplanding/business-pro@2x.png"
          alt="Business pro"
        />
        <div class="group-50"></div>
      </div>
      <img
        class="open-pro-lets-me-q-2"
        src="/otplanding/--open-pro-lets-me-q@2x.png"
        alt="Open PRO lets me q"
      />
      <div class="rectangle-10"></div>
      <div class="frame-2">
        <e-fakture />
        <ino-fakture />
        <baza-kupaca-i-dobavljaca />
        <baza-roba />
        <analitika-potrazivanja-i-dugovanja :anastasiaDanUxB="analitikaPotrazivanjaIDugovanja1Props.anastasiaDanUxB" />
        <analitika-potrazivanja-i-dugovanja :anastasiaDanUxB="analitikaPotrazivanjaIDugovanja2Props.anastasiaDanUxB" />
        <div class="automatizovana-arhivska-knjiga-2">
          <img
            class="path-16"
            src="/otplanding/path-6@2x.png"
            alt="Path"
          />
          <div class="anastasia-dan-ux-b-18 inter-medium-link-water-16px">automatizovana Arhivska knjiga</div>
        </div>
        <div class="document-management-2">
          <img
            class="path-16"
            src="/otplanding/path-6@2x.png"
            alt="Path"
          />
          <div class="anastasia-dan-ux-b-19 inter-medium-link-water-16px">
            <span class="span-15 inter-medium-link-water-16px">upravljanje dokumentacijom DMS </span
            ><span class="span-15 inter-light-link-water-16px">2GB</span>
          </div>
        </div>
        <direktna-komunikacija-sa-knjigovodjom />
      </div>
      <div class="rectangle-11"></div>
      <div class="x1-mesec-promo">
        <div class="start-free-trial-6 inter-semi-bold-white-20px">1 mesec besplatno</div>
        <p class="start-free-trial-7 inter-normal-white-13px">
          <span class="span-15 inter-normal-white-13px"> za klijente </span
          ><span class="span-15 inter-medium-white-13px">otp banke</span>
        </p>
        <p class="start-free-trial-8 inter-light-white-12px">
          nakon isteka promo perioda&nbsp;&nbsp;cena 1200 RSD mesečno
        </p>
      </div>
      <div class="rectangle-12"></div>
      <button-starter package="premium" @start="$emit('start', 'otp-business-premium')" />
    </div>
  </div>
</template>

<script>
import EFakture from "./EFakture";
import InoFakture from "./InoFakture";
import BazaKupacaIDobavljaca from "./BazaKupacaIDobavljaca";
import BazaRoba from "./BazaRoba";
import AnalitikaPotrazivanjaIDugovanja from "./AnalitikaPotrazivanjaIDugovanja";
import DirektnaKomunikacijaSaKnjigovodjom from "./DirektnaKomunikacijaSaKnjigovodjom";
import ButtonStarter from "./ButtonStarter";
export default {
  name: "Premium",
  components: {
    EFakture,
    InoFakture,
    BazaKupacaIDobavljaca,
    BazaRoba,
    AnalitikaPotrazivanjaIDugovanja,
    DirektnaKomunikacijaSaKnjigovodjom,
    ButtonStarter,
  },
  props: ["className", "analitikaPotrazivanjaIDugovanja1Props", "analitikaPotrazivanjaIDugovanja2Props"],
};
</script>

<style>
.premium-1 {
  height: 543px;
  margin-right: -4px;
  min-width: 364px;
  position: relative;
}

.overlap-group1-6 {
  align-items: center;
  background-image: url(/otplanding/rectangle-5@2x.png);
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  min-height: 543px;
  padding: 13px 23px;
  position: relative;
  width: 360px;
}

.flex-row-2 {
  align-items: flex-start;
  display: flex;
  gap: 85px;
  height: 24px;
  margin-left: 0.58px;
  margin-top: 13px;
  min-width: 297px;
}

.business-pro {
  align-self: flex-end;
  height: 23px;
  width: 98px;
}

.group-50 {
  background-image: url(/otplanding/otp-transprarent-3@2x.png);
  background-position: 50% 50%;
  background-size: cover;
  height: 22px;
  width: 115px;
}

.open-pro-lets-me-q-2 {
  align-self: flex-end;
  height: 18px;
  margin-right: 9.77px;
  margin-top: 27px;
  width: 209px;
}

.rectangle-10 {
  background-color: var(--onyx);
  height: 3px;
  margin-top: 2px;
  width: 300px;
}

.frame-2 {
  align-items: flex-start;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  position: relative;
  width: 307px;
}

.automatizovana-arhivska-knjiga-2 {
  height: 24px;
  min-width: 260px;
  position: relative;
}

.path-16 {
  height: 9px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 12px;
}

.anastasia-dan-ux-b-18 {
  left: 21px;
  letter-spacing: -0.25px;
  line-height: 24px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 237px;
}

.document-management-2 {
  height: 24px;
  margin-right: -2px;
  min-width: 309px;
  position: relative;
}

.anastasia-dan-ux-b-19 {
  left: 21px;
  letter-spacing: -0.25px;
  line-height: 24px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 286px;
}

.rectangle-11 {
  background-color: var(--onyx);
  height: 3px;
  margin-top: 8px;
  width: 300px;
}

.x1-mesec-promo {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 8px;
  margin-top: 8px;
  min-height: 92px;
  width: 296px;
}

.start-free-trial-6 {
  letter-spacing: -0.25px;
  line-height: 24px;
  margin-right: 7px;
  min-width: 177px;
  white-space: nowrap;
}

.start-free-trial-7 {
  letter-spacing: -0.25px;
  line-height: 24px;
  margin-right: 10px;
  min-width: 126px;
  white-space: nowrap;
}

.start-free-trial-8 {
  letter-spacing: -0.25px;
  line-height: 24px;
  margin-right: 6px;
  min-width: 290px;
  text-align: center;
  white-space: nowrap;
}

.rectangle-12 {
  background-color: var(--onyx);
  height: 3px;
  margin-top: 6px;
  width: 298px;
}

.premium-1.premium-2 .flex-row-2 {
  margin-left: 0.59px;
}
</style>
